import React, { useState, useRef } from 'react';
import {
  Button, Radio,
  FormController,
  FormLabel, RadioGroup, SelectionControlLabel, IconButton, Card
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { Close } from '@one-thd/sui-icons';
import { NO } from '../constants';

const keyToLabel = {
  neverSignedUp: 'I don’t remember signing up for emails',
  tooMany: 'I receive too many emails',
  cantView: 'I can’t view the emails',
  arntRelevant: 'The emails aren’t relevant to me'
};

const checkBoxKeys = Object.keys(keyToLabel);

export const optOutSubmitButton = 'opt-out-submit-button';
export const optOutReasonCloseButton = 'opt-out-reason-close-button';

export const OptOutReasonFeedback = ({
  selectedOptOuts,
  setSelectedOptOuts,
  callApi,
}) => {
  const [selectedOption, setSelectedOption] = useState('');
  const optOutRef = useRef();

  const handleChange = (event, value) => {
    setSelectedOption(keyToLabel[value]);
  };

  const submitDisabled = !selectedOption;

  const submitOptOutReason = () => {
    const subscriptions = selectedOptOuts.map((opt) => {
      return {
        type: opt,
        status: NO,
        optOutReasonFeedback: selectedOption
      };
    });
    callApi(subscriptions);
    setSelectedOption('');
    setSelectedOptOuts([]);
  };

  const handleClose = () => {
    setSelectedOptOuts([]);
  };

  return (selectedOptOuts?.length !== 0) && (
    <Card grow="true" data-testid="optOutReasonCard">
      <div
        data-testid="optOutReasonFeedback"
        ref={optOutRef}
      >
        <div className="sui-flex sui-justify-between sui-items-center">
          <FormLabel>
            To help us improve your experience, please tell us why you unsubscribed.
          </FormLabel>
          <IconButton
            icon={Close}
            aria-label={optOutReasonCloseButton}
            onClick={handleClose}
          />
        </div>
        <FormController
          fullWidth
          component="fieldset"
        >
          <RadioGroup onChange={handleChange}>
            {checkBoxKeys.map((key) => (
              <SelectionControlLabel value={key} key={key} label={keyToLabel[key]}>
                <Radio />
              </SelectionControlLabel>
            ))}
          </RadioGroup>
        </FormController>
        <div className="sui-grid sui-grid-cols-8">
          <div className="sui-col-span-7" />
          <div className="sui-col-span-1">
            <Button disabled={submitDisabled} data-testid={optOutSubmitButton} fullWidth onClick={submitOptOutReason}>
              Submit
            </Button>
          </div>
        </div>
      </div>
    </Card>
  );
};

OptOutReasonFeedback.propTypes = {
  callApi: PropTypes.func.isRequired,
  setSelectedOptOuts: PropTypes.func.isRequired,
  selectedOptOuts: PropTypes.arrayOf(PropTypes.string).isRequired,
};
